import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';
import ClaimDetailDialog from '../../components/Dialogs/ClaimDetailDialog';

interface ClaimDetailDialogContextType {
  openDialog: (claimId: string) => void;
  closeDialog: () => void;
}

const ClaimDetailDialogContext = createContext<ClaimDetailDialogContextType | undefined>(undefined);

export const useClaimDetailDialog = (): ClaimDetailDialogContextType => {
  const context = useContext(ClaimDetailDialogContext);
  if (!context) {
    throw new Error('useClaimDetailDialog must be used within ClaimDetailDialogProvider');
  }
  return context;
};

interface ClaimDetailDialogProviderProps {
  children: ReactNode;
}

export const ClaimDetailDialogProvider: React.FC<ClaimDetailDialogProviderProps> = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [claimId, setClaimId] = useState<string | null>(null);

  const openDialog = useCallback((id: string) => {
    setClaimId(id);
    setIsVisible(true);
  }, []);

  const closeDialog = useCallback(() => {
    setIsVisible(false);
    setClaimId(null);
  }, []);

  return (
    <ClaimDetailDialogContext.Provider value={{ openDialog, closeDialog }}>
      {children}
      <ClaimDetailDialog
        visible={isVisible}
        claimId={claimId}
        onClose={closeDialog}
      />
    </ClaimDetailDialogContext.Provider>
  );
};
